<template>
  <div>
  <Card>
      <Row>
        <!-- <i-col span="18"> -->
          <!-- <Form ref="searchForm" inline :model="searchForm" :label-width="120" @submit.native.prevent>
            <FormItem label="标签/Volumes" prop="name">
              <i-input v-model="searchForm.name" placeholder="请输入标签/Volumes" style="width: 200px;"></i-input>
            </FormItem>
            <FormItem :label-width="0">
              <Button type="primary" @click="getVolumesList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form> -->
        <!-- </i-col> -->
        <i-col span="24" :md="2" style="float:right">
          <Button @click="getVolumesList()" type="primary" :style="{marginBottom: '10px', float: 'right'}" icon="md-refresh">刷新</Button>
        </i-col>
       </Row>
      <tables search-place="top" v-model="tableData" :columns="columns"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getVolumesList"></page>
        </div>
     </Row>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getVolumesList } from '@/api/cloud'
export default {
  name: 'VolumesList',
  components: {
    Tables
  },
  data () {
    return {
      count: 1,
      size: 10,
      page: 1,
      change: false,
      ordering: null,
      columns: [
        { title: '名称', key: 'name', align: 'center', minWidth: 120 },
        { title: '总量', key: 'storage', align: 'center', minWidth: 100 },
        { title: '访问模式', key: 'access_modes', align: 'center', minWidth: 150 },
        { title: '回收策略', key: 'reclaim_policy', align: 'center', minWidth: 100 },
        { title: '状态', key: 'status', align: 'center', minWidth: 100 },
        { title: '声明', key: 'declare', align: 'center', minWidth: 180 },
        { title: '创建时间', key: 'create_time', align: 'center', minWidth: 150 }
      ],
      tableData: [],
      changeLoadingShow: false,
      searchForm: {
        name: null
      },
      listStyle: {
        width: '250px',
        height: '300px'
      }
    }
  },
  methods: {
    getVolumesList () {
      getVolumesList().then(res => {
        this.tableData = res.data
        this.count = res.data.length
      })
    },
    searchReset () {
      this.searchForm.name = null
    }
  },
  mounted: function () {
    this.getVolumesList()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
